'use client'

import { usePathname, useRouter } from '@/i18n/navigation'
import { useEffect } from 'react'
import { PROVIDER_ROUTES } from '../constants/routes'
import { useAuth } from '../store/auth'
import { AccountType } from '../types/enums/account-type.enum'

type Props = {
  children: React.ReactNode
}

export const AccountTypeGuard: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, accountType, status } = useAuth()
  const router = useRouter()
  const pathname = usePathname()

  useEffect(() => {
    if (status === 'pending') return

    if (
      isAuthenticated &&
      accountType === AccountType.PROVIDER &&
      !pathname.includes(PROVIDER_ROUTES.base)
    ) {
      return router.replace(PROVIDER_ROUTES.trips)
    }
  }, [isAuthenticated, accountType, router, status, pathname])

  return children
}
